import * as actions from "./actions";

let initialState = {
  sessionMinutes: {
    sending: false,
    sent: false,
    error: null,
  },
  userData: {
    fetching: false,
    fetched: false,
    error: null,
    data: {},
  },
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case actions.USER_DATA_FETCH_REQUEST:
      return Object.assign({}, state, {
        userData: Object.assign({}, state.userData, {
          fetching: true,
        }),
      });
    case actions.USER_DATA_FETCH_SUCCESS:
      return Object.assign({}, state, {
        userData: Object.assign({}, state.userData, {
          fetching: false,
          fetched: true,
          error: null,
          data: action.response,
        }),
      });
    case actions.USER_DATA_FETCH_ERROR:
      return Object.assign({}, state, {
        userData: Object.assign({}, state.userData, {
          fetching: false,
          fetched: true,
          error: action.error,
        }),
      });
    case actions.SET_SESSION_REQUEST:
      return Object.assign({}, state, {
        sessionMinutes: Object.assign({}, state.sessionMinutes, {
          sending: true,
        }),
      });
    case actions.SET_SESSION_SUCCESS:
      return Object.assign({}, state, {
        sessionMinutes: Object.assign({}, state.sessionMinutes, {
          sending: false,
          sent: true,
          error: null,
        }),
      });
    case actions.SET_SESSION_ERROR:
      return Object.assign({}, state, {
        sessionMinutes: Object.assign({}, state.sessionMinutes, {
          sending: false,
          sent: true,
          error: action.error,
        }),
      });
    default:
      return state;
  }
};

export default settings;
